/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function EyeClosedIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "eye-closed", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M4.5 12.5C6 15 8.5 17.5 12.5 17.5C16.5 17.5 19 15 20.5 12.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M15.5 17L16.5 19.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M7 15.5L5.5 17.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 17.5V20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M18 15.5L19.5 17.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9.5 17L8.5 19.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(EyeClosedIcon);
export default ForwardRef;
//# sourceMappingURL=eyeClosedIcon.js.map